// extracted by mini-css-extract-plugin
export default {"user-link":"_1UaZ4","userLink":"_1UaZ4","link-banned":"_21qw-","linkBanned":"_21qw-"};